import ImageFile from "./imageFile";

export default ImageFile;
